export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8464.cb0c236f.jpg";